import { createClient } from '@supabase/supabase-js'

// import.meta.env only exists under Vite — `?? {}` lets this module load
// under plain `node --test` too (no bundler defines it there).
const env = import.meta.env ?? {}
const supabaseUrl = env.VITE_SUPABASE_URL
const supabaseAnonKey = env.VITE_SUPABASE_ANON_KEY

if (!supabaseUrl || !supabaseAnonKey) {
  console.error(
    '[AcdyON] Missing Supabase env vars. Set VITE_SUPABASE_URL and VITE_SUPABASE_ANON_KEY in frontend/.env.production before deploying.'
  )
}

// createClient is called with fallback strings so the module never throws —
// auth calls will simply fail gracefully rather than crashing the whole app.
export const supabase = createClient(
  supabaseUrl || 'https://placeholder.supabase.co',
  supabaseAnonKey || 'placeholder-anon-key'
)
